import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {AdobeTrackingQueue} from '@app/services/analytics/models/adobe-tracking-data';
import {EddlTrackingQueue} from '@app/services/analytics/EDDL/models/eddl-adobe-tracking-data';

@Injectable({
  providedIn: 'root',
})
export class DpcEddlQueueService {
  private queue$: BehaviorSubject<AdobeTrackingQueue[] | EddlTrackingQueue[]> = new BehaviorSubject<
    AdobeTrackingQueue[] | EddlTrackingQueue[]
  >([]);

  updateQueue(data: AdobeTrackingQueue | EddlTrackingQueue) {
    if (
      this.queue$
        .getValue()
        .some(
          (q) => q.event.collectToken === data.event.collectToken && q.event.collectState === data.event.collectState
        )
    ) {
      this.queue$.next(
        this.queue$.getValue().map((qE) => {
          if (qE.event.collectToken === data.event.collectToken && qE.event.collectState === data.event.collectState) {
            return data;
          }
          return qE;
        })
      );
    } else {
      this.queue$.next([...this.queue$.getValue(), data]);
    }
  }

  getQueue(): AdobeTrackingQueue[] | EddlTrackingQueue[] {
    return this.queue$.getValue();
  }

  getQueue$(): Observable<AdobeTrackingQueue[] | EddlTrackingQueue[]> {
    return this.queue$.asObservable();
  }

  existInQueue(data: AdobeTrackingQueue | EddlTrackingQueue): boolean {
    return false;
  }

  clearQueue(collectToken?: string) {
    if (collectToken) {
      this.queue$.next(this.queue$.getValue()?.filter((q) => q.event.collectToken !== collectToken));
    } else {
      this.queue$.next([]);
    }
  }
}
